import { useState, useRef, useEffect } from "react";
import CustomInput from "../../../components/CustomInput/CustomInput";
import {
  Progress,
  Tooltip,
  Table,
  Button,
  Input,
  Space,
  Spin,
  Select,
  DatePicker,
} from "antd";
import Highlighter from "react-highlight-words";
import type { FilterConfirmProps } from "antd/es/table/interface";
import type { ColumnsType, ColumnType } from "antd/es/table";
import { DownOutlined, SearchOutlined, UpOutlined } from "@ant-design/icons";
import type { InputRef } from "antd";
import { activeUser } from "../../../services/AuthServices";
import { RoleType } from "../../../models/Role";
import { Notification, NotificationType } from "../../../models/Notification";
import { PdfPreview } from "../../../components/PdfPreview/PdfPreview";
import { getParticipantAccommodationReportTemplate } from "../../../document-templates/ParticipantAccommodationReportTemplate";
import { useApplicationContext } from "../../../application/ApplicationContext";
import "./Participants.scss";
import { getAllParticipantsEvent } from "../../../services/EventService";
import { AxiosResponse } from "axios";
import moment from "moment";
import { reservedRegistration } from "../../../services/RegistrationService";
import { getAllNotifications } from "../../../services/NotificationService";
import { formatDate, formatTime } from "../../../core/Utility";
import { RegistrationStatus } from "../../../models/Registration";
import { updateOneParticipantWithRoomKind } from "../../../services/ParticipantService";
import { OptionsArray } from "../../../components/AccommodationData/AccommodationData";
import { Option } from "antd/es/mentions";
import { Toast } from "primereact/toast";
import CustomButton from "../../../components/AccommodationData/CustomButton/CustomButton";
import dayjs from "dayjs";
import AccordionIcon from "../../../assets/agendas-accordion-icon.png";

const Participants = (props: any) => {
  const { setNotificationNumber } = useApplicationContext();
  const searchInput = useRef<InputRef>(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState<
    string | number | symbol
  >("");
  const [inputData, setInputData] = useState<any>({});
  const [getAllParticipants, setGetAllparticipants] = useState([]);
  const [filteredAllParticipants, setFilteredAllparticipants] = useState([]);
  const [load, setLoad] = useState<boolean>(false);
  const [tableKey, setTableKey] = useState(0);
  const [openExportButtons, setOpenExportButtons] = useState<boolean>(false);
  const [activeSpinner, setActiveSpinner] = useState(false);
  const [roomKindOptions, setRoomKindOptions] = useState([]);
  const [roomKindFilter, setRoomKindFilter] = useState([]);
  const [roomTypeOptions, setRoomTypeOptions] = useState();
  const [originalsDataParticipant, setOriginalsDataParticipant] = useState([]);
  const toast = useRef<any>(null);
  const [pageNumber, setPageNumber] = useState<any>(1);
  const { RangePicker } = DatePicker;
  const [totalNumber, setTotalNumber] = useState<any>();
  const [full, setFull] = useState<any>();
  const [reserved, setReserved] = useState<any>();
  const [free, setFree] = useState<any>();
  const [roomType, setRoomType] = useState([]);
  const [roomKind, setRoomKind] = useState([]);
  const [openMenuRT, setOpenMenuRT] = useState(false);
  const [openMenuRK, setOpenMenuRK] = useState(false);
  const [paginationNumber, setPaginationNumber] = useState<any>(30);

  const statusOptions = [
    { text: "Uplaćeno", value: RegistrationStatus.Paid },
    { text: "Rezervisano", value: RegistrationStatus.Reserved },
    { text: "Odobreno", value: RegistrationStatus.Approved },
  ];

  const [pdfData, setPdfData] = useState<any>(
    getParticipantAccommodationReportTemplate(
      filteredAllParticipants,
      props.data.name
    )
  );

  useEffect(() => {
    let newMapRoomKind = props?.event?.roomKind?.map((el: any) => {
      return { label: el.name, value: el.id, id: el.id };
    });
    let newMaproomKindFilter = props?.event?.roomKind?.map((el: any) => {
      return { text: el.name, value: el.name };
    });
    setRoomKindOptions(newMapRoomKind);
    setRoomKindFilter(newMaproomKindFilter);

    const totalNumber = props?.data?.roomTypes?.reduce(
      (total: number, roomType: any) => total + roomType.totalNumber,
      0
    );
    setTotalNumber(totalNumber);

    const full = props?.data?.roomTypes?.reduce(
      (total: number, roomType: any) => total + roomType.usedNumber,
      0
    );
    setFull(full);

    const reserved = props?.data?.roomTypes?.reduce(
      (total: number, roomType: any) => total + roomType.reservedNumber,
      0
    );
    setReserved(reserved);

    let free = totalNumber - (full + reserved);
    setFree(free);
  }, [props]);

  const downloadPdfDocument = useRef(null);
  const printPdfDocument = useRef(null);

  useEffect(() => {
    setActiveSpinner(true);
    getAllParticipantsEvent(props?.event?.id, props?.data?.id).then(
      (response: AxiosResponse) => {
        let mapParticipants = response.data.result?.map(
          (oneParticipant: any) => {
            let dateFrom = moment(oneParticipant?.registration_date[0]).format(
              "DD.MM.YYYY"
            );

            let dateTo = moment(oneParticipant?.registration_date[1]).format(
              "DD.MM.YYYY"
            );

            return { ...oneParticipant, dateTo: dateTo, dateFrom: dateFrom };
          }
        );

        let sort = mapParticipants.sort((a: any, b: any) => {
          const roomIdA = a.registration_roomId;
          const roomIdB = b.registration_roomId;

          if (roomIdA < roomIdB) {
            return -1;
          } else if (roomIdA > roomIdB) {
            return 1;
          } else {
            return 0;
          }
        });

        let finalList: any = [];
        for (let i = 0; i < sort.length; i++) {
          finalList.push(sort[i]);
          if (
            i < sort.length - 1 &&
            sort[i].registration_roomId !== sort[i + 1].registration_roomId
          ) {
            sort[i].split = true;
          }
        }

        let tipoviSoba = finalList.map((obj: any) => obj.roomtypename);

        let rezultat: any = [];
        let vidjeno: any = {};

        for (let i = 0; i < tipoviSoba.length; i++) {
          let item = tipoviSoba[i];
          let roomtypename = item;

          if (!vidjeno[roomtypename]) {
            rezultat.push(item);
            vidjeno[roomtypename] = true;
          }
        }

        let data = rezultat.map((el: any) => {
          return { text: el, value: el };
        });

        setRoomTypeOptions(data);
        setOriginalsDataParticipant(finalList);
        setGetAllparticipants(finalList);
        setFilteredAllparticipants(finalList);
        setTableKey((prevKey) => prevKey + 1);
        setActiveSpinner(false);
      }
    );
  }, [load]);

  useEffect(() => {
    setInputData(props.data);
  }, [props.data]);

  type DataIndex = keyof any;

  const getColumnSearchProps = (dataIndex: DataIndex): ColumnType<any> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Pretraži po imenu`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => {
              handleSearch(selectedKeys as string[], confirm, dataIndex);
            }}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, border: "none" }}
          >
            Pretraži
          </Button>
          <Button
            onClick={() => {
              clearFilters && handleReset(clearFilters);
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              close();
              setSearchedColumn("");
            }}
            size="small"
            style={{ width: 90 }}
          >
            Poništi
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#C7363D" : undefined }} />
    ),
    onFilter: (
      value,
      record //@ts-ignore
    ) =>
      (record[dataIndex] ?? "")
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
            color: "#0D4077",
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const [numberPersonOfRoomValues, setNumberPersonOfRoomValues] = useState<any>(
    []
  );

  const handleInputChange = (value: string, key: any) => {
    let allParticipants = [...getAllParticipants];
    let filterAllParticipantWithSameRoomId: any = allParticipants?.filter(
      (participant: any) =>
        participant.registration_roomId == key.registration_roomId
    );

    filterAllParticipantWithSameRoomId?.map(
      (el: any) => (el.roomNumber = value)
    );

    setGetAllparticipants(allParticipants);

    setNumberPersonOfRoomValues((prevValues: any) => {
      const index = prevValues.findIndex(
        (item: any) => item.registration_id === key.registration_id
      );
      if (index !== -1) {
        const updatedValues = [...prevValues];
        updatedValues[index] = {
          registration_id: key.registration_id,
          value: value,
        };
        return updatedValues;
      }
      return [
        ...prevValues,
        { registration_id: key.registration_id, value: value },
      ];
    });
  };

  const columns: ColumnsType<any> = [
    {
      title: "Red. broj",
      width: 70,
      dataIndex: "firstName",
      key: "firstName",
      render: (firstName, text, index) => {
        return (
          <span className="blue-text">
            {(pageNumber - 1) * paginationNumber + index + 1}
          </span>
        );
      },
    },
    {
      title: "Status",
      width: 160,
      dataIndex: "registration_status",
      key: "registration_status",
      filters: statusOptions,
      onFilter: (value: any, record: any) =>
        record?.registration_status === value,
      render: (text, record) => (
        <span style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{
              background:
                record.registration_status == "Rezervisano"
                  ? "#FAAD14"
                  : record.registration_status == "Uplaćeno"
                  ? "#52C41A"
                  : "#0D4077",
              width: "7px",
              height: "7px",
              marginRight: "10px",
              borderRadius: "50%",
            }}
          ></div>
          {record.registration_status}
        </span>
      ),
    },
    {
      title: "Ime",
      dataIndex: "firstName",
      key: "firstName",
      sorter: (a, b) => (a.firstName < b.firstName ? -1 : 1),
      ...getColumnSearchProps("firstName"),
    },
    {
      title: "Prezime",
      dataIndex: "lastName",
      key: "lastName",
      sorter: (a, b) => (a.lastName < b.lastName ? -1 : 1),
      ...getColumnSearchProps("lastName"),
    },
    // {
    //   title: "Događaj",
    //   dataIndex: "eventname",
    //   key: "eventname",
    //   ...getColumnSearchProps("eventname"),
    // },
    {
      title: "Datum smeštaja",
      width: 190,
      dataIndex: "dateFrom",
      key: "registration_date",
      render: (text, record) => (
        <span>{`${record.dateFrom} - ${record.dateTo}`}</span>
      ),
    },

    {
      title: "Tip smeštaja",
      dataIndex: "roomtypename",
      key: "roomtypename",
      filters: roomTypeOptions, //@ts-ignore
      onFilter: (value: any, record: any) => record?.roomtypename === value,
      render: (roomtypename) => (
        <span className="blue-text">{roomtypename ?? "/"}</span>
      ),
      // ...getColumnSearchProps("roomtypename"),
    },
    {
      title: "Tip sobe",
      dataIndex: "roomKind_name",
      key: "roomKind_name",
      width: 270,
      filters: roomKindFilter,
      onFilter: (value: any, record: any) => {
        return record?.roomKind_name === value;
      },
      // ...getColumnSearchProps("roomtypename"),
      render: (text, record) => {
        return (
          <>
            {props?.event?.roomKind && (
              <Select
                placeholder="Tip sobe"
                className="dropdown-room-type"
                value={record?.roomKind_name || ""}
                onChange={(option) => {
                  setActiveSpinner(true);
                  updateOneParticipantWithRoomKind(record.id, option)
                    .then((res: AxiosResponse) => {
                      setLoad(!load);
                      setActiveSpinner(false);
                      return toast?.current?.show({
                        severity: "success",
                        detail: "Uspešno sačuvan tip sobe!",
                        life: 3000,
                      });
                    })
                    .catch((err: any) => {
                      setActiveSpinner(false);
                      if (err) {
                        let text = err?.response?.data?.message;
                        toast?.current?.show({
                          severity: "error",
                          detail: `${text}`,
                          life: 3000,
                        });
                        setLoad(!load);
                      }
                    });
                }}
              >
                {roomKindOptions?.map((el: OptionsArray, i: any) => (
                  <Option key={i} value={el.value} style={{ width: "100%" }}>
                    {el.label}
                  </Option>
                ))}
              </Select>
            )}
          </>
        );
      },
    },
    {
      title: "Broj osoba",
      width: 120,
      dataIndex: "numberPersonInRoom",
      key: "numberPersonInRoom",
      sorter: (a, b) => (a.numberPersonInRoom < b.numberPersonInRoom ? -1 : 1),
      // ...getColumnSearchProps("numberPersonInRoom"),
    },
    {
      title: "Broj sobe",
      width: 200,
      dataIndex: "roomNumber",
      key: "roomNumber",
      ...getColumnSearchProps("roomNumber"),
      render: (text, record) => (
        <Input
          className="dropdown-room-type"
          type="text"
          value={record.roomNumber == null ? "" : record.roomNumber} // koristimo defaultValue
          onChange={(e) => handleInputChange(e.target.value, record)}
        />
      ),
    },
    {
      title: "Opcije",
      key: "action",
      fixed: "right",
      width: 170,
      align: "center",
      render: (_, record) => {
        const sameRoomRegistrations = getAllParticipants.filter(
          (reg: any) => reg.registration_roomId === record.registration_roomId
        ).length;

        return (
          <Space size="middle">
            {record.registration_status == RegistrationStatus.Paid && (
              <span
                className="action-button"
                style={{ cursor: "pointer" }}
                onClick={() => handleSaveButton(record.registrationId, record)}
              >
                Sačuvaj
              </span>
            )}

            {record.registration_status == RegistrationStatus.Approved && (
              <>
                {sameRoomRegistrations < record.numberPersonInRoom ? (
                  <span
                    className="action-button"
                    style={{ cursor: "not-allowed" }}
                  >
                    Čeka odobrenje
                  </span>
                ) : (
                  <span
                    className="action-button"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      handleSaveButton(record.registrationId, record)
                    }
                  >
                    Odobri
                  </span>
                )}
              </>
            )}

            {record.registration_status == RegistrationStatus.Reserved && (
              <span
                className="action-button"
                style={{ cursor: "pointer" }}
                onClick={() => handleSaveButton(record.registrationId, record)}
              >
                Sačuvaj
              </span>
            )}
          </Space>
        );
      },
    },
  ];

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };

  const handleSaveButton = (id: string, record: any) => {
    let roomNumber = numberPersonOfRoomValues?.find(
      (room: any) => id == room.registration_id
    );

    let roomTypeValue = roomNumber == undefined ? "" : roomNumber.value;

    let data = { roomNumber: roomTypeValue };
    setActiveSpinner(true);

    let currentRegistration: any = getAllParticipants
      ?.filter(
        (el: any) => el.registration_roomId == record.registration_roomId
      )
      .find((e: any) => e.registration_applicantId == null);

    let sendId =
      record.registration_registrationCompanyId == null
        ? currentRegistration.registration_id
        : id;

    reservedRegistration(sendId, data)
      .then((res: AxiosResponse) => {
        setLoad(!load);
        props.changeCurrentActive();
        setActiveSpinner(false);

        toast?.current?.show({
          severity: "success",
          detail: "Proces je uspešno obavljen.",
          life: 3000,
        });

        if (res.data.status !== "success") {
          toast?.current?.show({
            severity: "error",
            detail: res.data.message,
            life: 3000,
          });
        }
      })
      .then(() => {
        let copyOfNewNotifications: Notification[] = [];
        getAllNotifications().then((response) => {
          response.data.result.map((item: any) => {
            if (
              activeUser?.role.name == RoleType.Agency &&
              item.type == NotificationType.AGENCY
            ) {
              copyOfNewNotifications.push(item);
            }
            if (
              activeUser?.role.name == RoleType.Employee &&
              item.type == NotificationType.EMPLOYEE
            ) {
              copyOfNewNotifications.push(item);
            }
            if (activeUser?.role.name == RoleType.Admin) {
              copyOfNewNotifications.push(item);
            }
          });
          const unseenNotifications = copyOfNewNotifications.filter(
            (oneNotification: Notification) => oneNotification.seen === false
          );
          setNotificationNumber(unseenNotifications.length);
        });
      });
  };

  const handleOpenExportButtons = () => {
    setOpenExportButtons(!openExportButtons);
  };

  ///Custom filter
  const handleRangeChange = (dates: any) => {
    if (!dates || dates.length !== 2) {
      // Ako nema izabranih datuma ili nisu ispravno postavljeni, resetujte niz na originalni
      if (originalsDataParticipant) {
        setGetAllparticipants(originalsDataParticipant);
      }
      return;
    }

    const start = new Date(dates[0]);
    const end = new Date(dates[1]);

    const filteredParticipant = originalsDataParticipant?.filter(
      (item: any) => {
        const momentStartDate = moment(item.registration_date[0]).add(
          1,
          "days"
        );
        const momentEndDate = moment(item.registration_date[1]);

        return (
          momentStartDate.isSameOrAfter(start, "day") &&
          momentEndDate.isSameOrBefore(end, "day")
        );
      }
    );

    const uniqueRoomIds: any = {};
    const filteredArray: any = [];

    filteredParticipant.forEach((obj: any) => {
      const roomId = obj.registration_roomId;
      if (!uniqueRoomIds[roomId]) {
        uniqueRoomIds[roomId] = true;
        filteredArray.push(obj);
      }
    });

    const roomType = filteredArray
      .map((item: any) => item.roomtypename)
      .reduce((acc: any, soba: any) => {
        const tipSobe = soba;

        const postojeciTip = acc.find((item: any) => item.type === tipSobe);

        if (postojeciTip) {
          postojeciTip.number++;
        } else {
          acc.push({ type: tipSobe, number: 1 });
        }

        return acc;
      }, []);

    let rk = filteredArray
      .map((item: any) => {
        if (item.roomKind_name !== null) {
          return item.roomKind_name;
        }
      })
      .filter((el: any) => el !== undefined);

    const roomKind = rk.reduce((acc: any, soba: any) => {
      const tipSobe = soba;
      const postojeciTip = acc.find((item: any) => item.type === tipSobe);

      if (postojeciTip) {
        postojeciTip.number++;
      } else {
        acc.push({ type: tipSobe, number: 1 });
      }

      return acc;
    }, []);

    let calcutaleAllRT = roomType?.reduce(
      (acc: number, item: any) => acc + item.number,
      0
    );

    let calcutaleAllRK = roomKind?.reduce(
      (acc: number, item: any) => acc + item.number,
      0
    );

    if (calcutaleAllRT - calcutaleAllRK > 0) {
      let lastColumn = {
        type: "Nije dodeljen tip sobe",
        number: calcutaleAllRT - calcutaleAllRK,
        color: "red",
      };
      roomKind.push(lastColumn);
    }

    setRoomType(roomType);
    setRoomKind(roomKind);

    const totalNumber = filteredArray.length;
    setTotalNumber(totalNumber);

    const full = filteredArray.filter(
      (item: any) => item.registration_status == RegistrationStatus.Paid
    );
    setFull(full.length);

    const reserved = filteredArray.filter(
      (item: any) => item.registration_status == RegistrationStatus.Reserved
    );
    setReserved(reserved.length);

    let free = totalNumber - (full.length + reserved.length);
    setFree(free);

    setGetAllparticipants(filteredParticipant);
  };

  const handleDisabledDates = (current: any) => {
    if (props?.event) {
      const from = moment(props.event.dateFrom);
      const to = moment(props.event.dateTo);

      let newDateFrom = moment(from, "DD-MM-YYYY").subtract(1, "days");
      let newDateTo = moment(to, "DD-MM-YYYY").add(1, "days");
      return newDateFrom >= current.$d || newDateTo <= current.$d;
    } else {
      return 0 >= current.$d || 0 <= current.$d;
    }
  };

  // populate pdf when data changes
  useEffect(() => {
    const newPdf = getParticipantAccommodationReportTemplate(
      filteredAllParticipants,
      props.data.name
    );
    setPdfData(newPdf);
  }, [filteredAllParticipants]);

  const handleExcelButton = () => {
    const filterObject = filteredAllParticipants.map((el: any) => {
      return {
        Ime: el.firstName,
        Prezime: el.lastName,
        Dogadjaj: el.eventname,
        Datum: `${el.dateFrom} - ${el.dateTo}`,
        Broj_osoba: el.numberPersonInRoom,
        Tip_sobe: el.roomtypename,
        Broj_sobe: el.roomNumber,
        Status: el.registration_status,
      };
    });

    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(filterObject);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "Lista učesnika u smestaju ");
    });
    setOpenExportButtons(false);
  };

  const saveAsExcelFile = (buffer: any, fileName: string) => {
    import("file-saver").then((module: any) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });
        module.default.saveAs(
          data,
          fileName +
            "_" +
            formatDate(new Date()) +
            "_" +
            formatTime(new Date()) +
            EXCEL_EXTENSION
        );
      }
    });
  };

  interface DataType {
    key: string;
    type: string;
    number: number;
    color?: string;
    //address: string;
    //tags: string[];
  }

  const columnsRT: ColumnsType<DataType> = [
    {
      title: "Tip",
      dataIndex: "type",
      key: "type",
      render: (text, record) => (
        <p className={record.color && "redItem"}>{text}</p>
      ),
    },
    {
      title: "Broj",
      dataIndex: "number",
      key: "number",
      render: (text, record) => (
        <p className={record.color && "redItem"}>{text}</p>
      ),
    },
  ];

  const HalfTable = () => {
    const totalDataCount = roomKind.length;
    const firstHalfData = roomKind.slice(0, Math.ceil(totalDataCount / 2));
    const secondHalfData = roomKind.slice(Math.ceil(totalDataCount / 2));

    return (
      <>
        <Table
          dataSource={firstHalfData}
          columns={columnsRT}
          pagination={false}
        />
        {secondHalfData.length == 0 ? null : (
          <Table
            dataSource={secondHalfData}
            columns={columnsRT}
            pagination={false}
          />
        )}
      </>
    );
  };

  return (
    <div className="participants">
      <Toast ref={toast} position={"top-right"} />
      <Spin spinning={activeSpinner}>
        <div className="header-a-c">
          <div className="custom-filter">
            <label>Filtriraj prema datumu:</label>
            <RangePicker
              className="range-date"
              showTime={false}
              onChange={handleRangeChange}
              defaultPickerValue={[
                dayjs(props?.event?.dateFrom),
                dayjs(props?.event?.dateTo),
              ]}
              disabledDate={handleDisabledDates}
              format="YYYY-MM-DD"
            />
          </div>
          <div className="first-row">
            <div className="form-box-total-room">
              <CustomInput
                label={"Ukupno soba:"}
                first={full}
                second={reserved}
                third={free}
              />
            </div>
            <Tooltip
              className="progress"
              title={`${full} Popunjeno / ${reserved} Rezervisano / ${free} Slobodno`}
            >
              <Progress
                percent={
                  +(
                    (reserved / (full + reserved + free)) * 100 +
                    (full / (full + reserved + free)) * 100
                  ).toFixed(2)
                }
                success={{ percent: (full / (full + reserved + free)) * 100 }}
              />
            </Tooltip>
          </div>
        </div>

        {roomType.length !== 0 && (
          <div className="type-acc">
            <div
              className="option-header"
              onClick={() => {
                setOpenMenuRT(!openMenuRT);
              }}
            >
              <p>Tipovi smeštaja</p>
              {openMenuRT ? <UpOutlined /> : <DownOutlined />}
            </div>
            <div className="body-t-a">
              {openMenuRT && (
                <Table
                  columns={columnsRT}
                  dataSource={roomType}
                  pagination={false}
                />
              )}
            </div>
          </div>
        )}

        {roomKind.length !== 0 && (
          <div className="type-acc">
            <div
              className="option-header o-h-red"
              onClick={() => {
                setOpenMenuRK(!openMenuRK);
              }}
            >
              <p>Tipovi soba</p>
              {openMenuRK ? <UpOutlined /> : <DownOutlined />}
            </div>
            <div className="body-t-a rk-table">
              {openMenuRK && <HalfTable />}
            </div>
          </div>
        )}

        <div className="second-row">
          <Table
            columns={columns}
            dataSource={getAllParticipants}
            scroll={{ x: 1850 }}
            rowKey={(data) => {
              return data.id;
            }}
            pagination={{
              onChange(current) {
                setPageNumber(current);
              },
              defaultPageSize: 30,
              showSizeChanger: true,
              pageSizeOptions: ["30", "50", "100"],
            }}
            onChange={(pagination, filters, sorter, extra) => {
              setPaginationNumber(pagination.pageSize);
              //@ts-ignore
              setFilteredAllparticipants(extra.currentDataSource);
            }}
            className="table-container"
            rowClassName={(record) =>
              record.split ? "ant-table-row-split" : ""
            }
          />

          <div className="button-container">
            <CustomButton
              danger={false}
              htmlType={""}
              type={"primary"}
              function={() => {
                handleOpenExportButtons();
              }}
              text={"Export"}
            />
          </div>
          {openExportButtons ? (
            <div className="btn-container footer-btn-container">
              <CustomButton
                danger={false}
                htmlType={""}
                type={"primary"}
                function={() => {
                  handleExcelButton();
                }}
                text={"Excel"}
              />
              <CustomButton
                danger={false}
                htmlType={""}
                type={"primary"}
                function={() => {
                  if (downloadPdfDocument.current) {
                    // @ts-ignore
                    downloadPdfDocument.current();
                  }
                }}
                text={"PDF"}
              />
              <CustomButton
                danger={false}
                htmlType={""}
                type={"primary"}
                function={() => {
                  if (printPdfDocument.current) {
                    // @ts-ignore
                    printPdfDocument.current();
                  }
                }}
                text={"Štampa"}
              />
            </div>
          ) : null}
        </div>
        <div className="document-preview">
          <PdfPreview
            pdfDefinition={pdfData}
            downloadDocument={downloadPdfDocument}
            printDocument={printPdfDocument}
            documentName={`Lista_ucesnika_u_smestaju_${
              formatDate(new Date()) + "_" + formatTime(new Date())
            }.pdf`}
          />
        </div>
      </Spin>
    </div>
  );
};

export default Participants;
